// extracted by mini-css-extract-plugin
export default {"shipping":"gi-z","header":"hi-z","adjustMarginAndPaddingNewDesign":"ii-z"};